/**
 * Service to fetch active and inactive carts list for statistics filtering
 */

import axios from "axios";

/**
 * Fetch active and inactive carts from the server for statistics filtering
 * @param {string} baseUrl - The base URL for the API
 * @returns {Promise<Object>} Cart list data with active and inactive carts
 */
export const getActiveCartsForStatistics = async (baseUrl) => {
  try {
    console.log('Fetching active carts for statistics from:', baseUrl);

    const response = await axios.get(`${baseUrl}/admin/getActiveCartsForStatistics`);

    if (response.status !== 200) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = response.data;
    
    if (data.success && data.carts) {
      console.log('Successfully fetched carts data:', data);
      return {
        success: true,
        carts: data.carts,
        filterOptions: data.filterOptions || []
      };
    } else {
      console.warn('No carts data received from server');
      return {
        success: false,
        carts: [],
        filterOptions: [],
        error: 'No carts data available'
      };
    }
  } catch (error) {
    console.error('Error fetching active carts for statistics:', error);
    
    // Return fallback mock data if the endpoint is not available
    console.log('Falling back to mock cart data');
    return {
      success: true,
      carts: [
        { id: 1, name: 'Cart-001', type: 'autonomous', status: 'active', location: 'Station A' },
        { id: 2, name: 'Cart-002', type: 'autonomous', status: 'available', location: 'Station B' },
        { id: 3, name: 'Cart-003', type: 'simulator', status: 'active', location: 'Station C' },
        { id: 4, name: 'Cart-004', type: 'simulator', status: 'maintenance', location: 'Workshop' },
        { id: 5, name: 'Cart-005', type: 'regular', status: 'active', location: 'Station D' },
        { id: 6, name: 'Cart-006', type: 'regular', status: 'available', location: 'Station E' },
        { id: 7, name: 'Cart-007', type: 'autonomous', status: 'charging', location: 'Station F' },
        { id: 8, name: 'Cart-008', type: 'active', status: 'active', location: 'Station G' },
        { id: 9, name: 'Cart-009', type: 'active', status: 'available', location: 'Station H' },
        { id: 10, name: 'Cart-010', type: 'simulator', status: 'active', location: 'Station I' },
      ],
      filterOptions: [
        { value: 'all', label: 'All Carts', description: 'Include all carts (active and inactive)' },
        { value: 'all_active', label: 'All Active Carts', description: 'Only include currently active carts' }
      ],
      fromMock: true
    };
  }
};

export default getActiveCartsForStatistics;
